import styles from "./profile.module.css";

import { useContext, useState } from "react";
import {
  Card,
  Typography,
  Descriptions,
  Tag,
  Button,
  Flex,
  Modal,
  Col,
  Row,
  message,
} from "antd";

import EditIcon from "@/icons/EditIcon";
import LockOpenIcon from "@/icons/LockOpenIcon";

import { UserContext } from "@/context/UserContext";
import { updateAvatar, deleteAvatar } from "@/api/employees";
import { getMe } from "@/api/auth";
import { getFullName, formateDate } from "@/utils";

import ChangePasswordModal from "@/components/modals/ChangePasswordModal";
import Breadcrumbs from "@/components/ui/Breadcrumbs";
import AvatarWithActions from "@/components/ui/AvatarWithActions";
import CopyableText from "@/components/ui/СopyableText";
import ChangeEmailModal from "@/components/modals/ChangeEmailModal";

import routes from "@/routes";

const { Title, Paragraph } = Typography;

const Profile = () => {
  const { user, setUser } = useContext(UserContext);
  const [isLoading, setIsLoading] = useState(false);
  const [showPasswordModal, setShowPasswordModal] = useState(false);

  const [showEmailModal, setShowEmailModal] = useState(false);

  const fio = getFullName(user.lastname, user.firstname, user.patronymic);

  const handleChangePassword = () => {
    Modal.confirm({
      title: "Сменить пароль",
      content:
        "После смены пароля все сессии будут закрыты. Вам необходимо будет авторизоваться с новым паролем.",
      okText: "Продолжить",
      cancelText: "Отменить",
      onOk() {
        setShowPasswordModal(true);
      },
    });
  };

  const handleSaveAvatar = async (file) => {
    const formData = new FormData();
    formData.append("avatar", file);

    try {
      await updateAvatar(formData);

      fetchData();
    } catch (error) {
      message.error(error.message);
    }
  };

  const handleDeleteAvatar = async () => {
    try {
      await deleteAvatar();

      fetchData();
    } catch (error) {
      message.error(error.message);
    }
  };

  const fetchData = async () => {
    setIsLoading(true);
    const data = await getMe();
    if (data.user) {
      setUser(data.user);
    }
    setIsLoading(false);
  };

  const handleSaveEmail = () => {
    fetchData();
    setShowEmailModal(false);
  };

  return (
    <>
      {user && (
        <>
          <Flex vertical gap={20}>
            <Flex vertical gap={12}>
              <Breadcrumbs
                items={[
                  {
                    title: "Главная",
                    href: routes.dashboards,
                  },
                  {
                    title: "Профиль",
                  },
                ]}
              />
              <Title level={2} className="no-margin">
                Профиль
              </Title>
            </Flex>

            <Card loading={isLoading}>
              <Row gutter={24} align="flex-start">
                <Col xs={24} sm={24} md={8}>
                  <Flex vertical align="start" gap={10}>
                    <AvatarWithActions
                      user={user}
                      saveAvatar={handleSaveAvatar}
                      deleteAvatar={handleDeleteAvatar}
                    />
                    <Paragraph
                      style={{ margin: 0, fontSize: 15, fontWeight: 500 }}
                    >
                      {fio}
                    </Paragraph>
                  </Flex>
                </Col>

                <Col xs={24} sm={24} md={16} className={styles.profileDetails}>
                  <Descriptions
                    column={1}
                    styles={{
                      label: { display: "inline-block", minWidth: "160px" },
                      content: {
                        display: "block",
                        marginLeft: "8px",
                        fontSize: 13,
                      },
                    }}
                  >
                    <Descriptions.Item label="Роль">
                      <Tag>{user.role}</Tag>
                    </Descriptions.Item>

                    <Descriptions.Item label="ФИО">
                      <CopyableText text={fio} />
                    </Descriptions.Item>

                    <Descriptions.Item label="Логин">
                      <CopyableText text={user.email} />
                    </Descriptions.Item>

                    <Descriptions.Item label="Дата рождения">
                      {formateDate(user.birthdate)}
                    </Descriptions.Item>

                    <Descriptions.Item label="Email для уведомлений">
                      <Flex gap={15} align="flex-start">
                        {user.secondary_email ? (
                          <CopyableText text={user.secondary_email} />
                        ) : (
                          <span style={{ color: "#BBBBBB" }}>Не указан</span>
                        )}
                        <Button
                          size="small"
                          color="default"
                          variant="text"
                          icon={<EditIcon style={{ fontSize: 14 }} />}
                          onClick={() => setShowEmailModal(true)}
                        />
                      </Flex>
                    </Descriptions.Item>
                  </Descriptions>
                </Col>
              </Row>
            </Card>

            <Button
              type="text"
              icon={<LockOpenIcon />}
              style={{ alignSelf: "flex-start", paddingInline: 24 }}
              onClick={handleChangePassword}
            >
              Сменить пароль
            </Button>
          </Flex>

          {showPasswordModal && (
            <ChangePasswordModal
              visible={showPasswordModal}
              onCancel={() => setShowPasswordModal(false)}
              onSave={() => setShowPasswordModal(false)}
            />
          )}

          {showEmailModal && (
            <ChangeEmailModal
              data={{ uuid: user.user_uuid }}
              visible={showEmailModal}
              onCancel={() => setShowEmailModal(false)}
              onSave={handleSaveEmail}
            />
          )}
        </>
      )}
    </>
  );
};

export default Profile;
